import Form from "../modules/form";
import ThemeMap from "../utils/map";

window.hcaptchaCallback = function (response) {
  window.form.submit(response);
};

const Contacts = {
  init() {
    window.form = new Form("#contact-form");
    ThemeMap.init(document.getElementById("map-wrap"));
  },
};

export default Contacts;
